/**
 * Marketing unsubscribe reasons and sources, as plain data.
 *
 * Kept out of `contract/email.ts` so the /descadastro page and the admin can
 * import them without pulling zod into the browser bundle; the contract
 * re-exports them and builds its enums from these.
 */

/** Why someone left the marketing list (the /descadastro page asks after the fact). */
export const UNSUBSCRIBE_REASONS = ["too_many", "not_relevant", "never_signed_up", "other"] as const;

export type UnsubscribeReason = (typeof UNSUBSCRIBE_REASONS)[number];

/** pt-BR labels for each reason, shared by the /descadastro page and the admin. */
export const UNSUBSCRIBE_REASON_LABELS: Record<UnsubscribeReason, string> = {
  too_many: "Recebo e-mails demais",
  not_relevant: "O conteúdo não tem a ver comigo",
  never_signed_up: "Não lembro de ter pedido esses e-mails",
  other: "Outro motivo",
};

/** Where an opt-out came from (`marketing_unsubscribes.source`, migration 0077). */
export const UNSUBSCRIBE_SOURCES = ["one_click", "confirm_page", "resend_broadcast", "manual"] as const;
